module.exports = __webpack_public_path__ + "img/Python.146716bd.svg";